import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { List, AutoSizer, CellMeasurerCacheInterface } from 'react-virtualized';
import { FlattenedNode } from './shapes';
import { withInfiniteLoaderHOC } from './infinite-loading-tree';

export const ListView = props => (
  <AutoSizer>
    {({ height, width }) => (
      // eslint-disable-next-line jsx-a11y/role-supports-aria-props
      <List
        aria-label={props.ariaLabel}
        // eslint-disable-next-line jsx-a11y/aria-proptypes
        aria-readonly={null} // remove from default props since it is not supported in our role
        tabIndex={-1}
        ref={props.registerChild}
        onRowsRendered={props.onRowsRendered}
        deferredMeasurementCache={props.deferredMeasurementCache}
        rowRenderer={props.rowRenderer(props.flattenedTree)}
        height={height}
        width={width}
        rowCount={props.rowCount}
        scrollToIndex={props.scrollToIndex}
        rowHeight={props.rowHeight}
        role="presentation"
        containerRole="presentation"
      />
    )}
  </AutoSizer>
);

export const ListViewWithInfiniteLoader = withInfiniteLoaderHOC(ListView);

const propTypes = {
  rowCount: PropTypes.number.isRequired,
  rowHeight: PropTypes.func.isRequired,
  scrollToIndex: PropTypes.number.isRequired,
  rowRenderer: PropTypes.func.isRequired,
  deferredMeasurementCache: PropTypes.shape(CellMeasurerCacheInterface).isRequired,
  flattenedTree: PropTypes.arrayOf(PropTypes.shape(FlattenedNode)).isRequired,
  onRowsRendered: PropTypes.func,
  registerChild: PropTypes.func,
  ariaLabel: PropTypes.string,
};

const defaultProps = {
  onRowsRendered: () => _.noop,
  registerChild: () => _.noop,
  ariaLabel: '',
};

ListView.defaultProps = defaultProps;
ListViewWithInfiniteLoader.defaultProps = defaultProps;

ListView.propTypes = propTypes;
ListViewWithInfiniteLoader.propTypes = propTypes;
